import React from 'react';
import { Tabs, Typography } from 'antd';
import {
  EditOutlined,
} from '@ant-design/icons';

import CorrectionQueue from '../../components/OwnerHub/CorrectionQueue';

const { Title, Text } = Typography;

// ─────────────────────────────────────────────────────────────────────────────
// Tab items
// ─────────────────────────────────────────────────────────────────────────────

const TAB_ITEMS = [
  {
    key: '1',
    label: (
      <span>
        <EditOutlined />
        {' '}Corrections
      </span>
    ),
    children: <CorrectionQueue />,
  },
];

// ─────────────────────────────────────────────────────────────────────────────
// Component
// ─────────────────────────────────────────────────────────────────────────────

const OwnerHub: React.FC = () => {
  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={2} style={{ margin: 0 }}>
          Owner Hub
        </Title>
        <Text type="secondary">
          Owner-level oversight: data quality reviews and pending corrections.
        </Text>
      </div>

      <Tabs
        items={TAB_ITEMS}
        type="card"
        size="middle"
        destroyInactiveTabPane={false}
        style={{ background: 'transparent' }}
      />
    </div>
  );
};

export default OwnerHub;
